import { gql } from '@apollo/client';

const GET_MASTERCODES_DATA = gql`
  query getMastercodes {
    mastercodes(where: { expired: false }) {
      id
      status
      orderItems {
        id
        licenseType
        product {
          id
          code
        }
      }
    }
  }
`;

export default GET_MASTERCODES_DATA;
